export default function Spinner() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-16 h-16 border-4 border-pink-500 rounded-full border-t-transparent animate-spin"></div>
    </div>
  );
}
